import http from "./httpService";

export function getQuickLinksOs() {
  return http.get("/quick-links-os");
}